class CompatibilityChecker {
    static checkLocalStorage() {
        let test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch(e) {
            return false;
        }
    }
}

export default CompatibilityChecker;


// WEBPACK FOOTER //
// ./src/Utils/CompatibilityChecker.js